import { render, staticRenderFns } from "./ProspectTripSuggestion.vue?vue&type=template&id=08dd4b84&scoped=true&"
import script from "./ProspectTripSuggestion.vue?vue&type=script&lang=js&"
export * from "./ProspectTripSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./ProspectTripSuggestion.vue?vue&type=style&index=0&id=08dd4b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd4b84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
